// extracted by mini-css-extract-plugin
export default {"link":"basket-link_link__t0aQm","text":"basket-link_text__W4DlF"};